function ErrorIcon(props)
{
    return(
<svg className={props.class?props.class:''} id="gallery" width="2rem" height="2rem" viewBox="0 0 24 24" fill="white"><g id="_23.Cancel" data-name="23.Cancel"><path d="M14,21H7A7,7,0,0,1,5.276,7.223a6,6,0,0,1,11.645.8,6.466,6.466,0,0,1,5.593,2.336l-1.542,1.274a4.492,4.492,0,0,0-4.718-1.458l-1.339.385L15,8.979A4,4,0,0,0,7.076,8.26l-.131.7-.7.106A5,5,0,0,0,7,19h7Z"/><rect x="18" y="12.757" width="2" height="8.485" transform="translate(-6.456 18.414) rotate(-45)"/><rect x="14.757" y="16" width="8.485" height="2" transform="translate(-6.456 18.414) rotate(-45)"/></g></svg>
    )
}

export default ErrorIcon